import { tv } from "tailwind-variants";

export const buttonVariants = tv({
  base: "duration-400 ease-out-quart relative inline-flex cursor-pointer items-center justify-center whitespace-nowrap rounded-md text-center font-sans text-[0.875rem] text-sm/none font-normal tracking-tight transition-colors focus-visible:outline-offset-2 xl:text-base/none",
  variants: {
    variant: {
      primary:
        "bg-nav-content-primary border-nav-content-primary text-nav-control group-hover:border-nav-button-hover group-hover:bg-nav-button-hover hover:border-nav-button-hover hover:bg-nav-button-hover border",
      secondary:
        "border-nav-content-primary text-nav-content-primary group-hover:bg-nav-content-primary group-hover:text-nav-control hover:bg-nav-content-primary hover:text-nav-control border min-[1140px]:px-4",
      tertiary:
        "bg-linear-to-r text-nav-content-primary rounded-none from-current to-current bg-[length:100%_1px] bg-[position:0%_100%] bg-no-repeat p-0 pb-1 tracking-[0.005em] transition-[background-size] duration-200 ease-out hover:bg-[length:0%_1px] hover:bg-[position:100%_100%] focus:rounded group-hover:bg-[length:0%_1px] group-hover:bg-[position:100%_100%]",
    },

    size: {
      base: "px-2.5 py-2 text-[0.875rem] xl:px-4 xl:py-3 xl:text-base/none",
      small: "px-2.5 py-2 text-sm/none min-[1140px]:text-sm/none",
    },
    isExternal: {
      true: "inline-flex items-center gap-[10px]",
    },
  },

  compoundVariants: [
    {
      variant: "tertiary",
      class: "px-0 pb-1 pt-0",
    },
  ],

  defaultVariants: {
    variant: "primary",
    size: "base",
    isExternal: false,
  },
});
